import Alpine from "alpinejs";

document.addEventListener("alpine:init", () => {
    Alpine.store('darkModeStore', {
      // Initialize state
      isDarkMode: false,

      // Initialize function
      initialize() {
        const storedPreference = localStorage.getItem('dark-mode');
        const defaultPreference =
          document.documentElement.dataset.defaultDarkmode === 'true';

        this.isDarkMode =
          storedPreference === null ? defaultPreference : storedPreference === 'true';

        document.documentElement.classList.toggle('dark', this.isDarkMode);
      },

      // Toggle dark mode
      toggleDarkMode() {
        this.isDarkMode = !this.isDarkMode;

        // Apply/remove dark mode class
        document.documentElement.classList.toggle('dark', this.isDarkMode);

        // Persist to localStorage
        localStorage.setItem('dark-mode', this.isDarkMode ? 'true' : 'false');
      },
    });
  });
